import { render, staticRenderFns } from "./Hutoverzicht.vue?vue&type=template&id=45f2e97d&scoped=true"
import script from "./Hutoverzicht.vue?vue&type=script&lang=js"
export * from "./Hutoverzicht.vue?vue&type=script&lang=js"
import style0 from "./Hutoverzicht.vue?vue&type=style&index=0&id=45f2e97d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f2e97d",
  null
  
)

export default component.exports